import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import components from '@vantis/components'
import '@vantis/components/style.css'
import { initializeAppContext } from '@/stores/appContext'
import { createDefaultI18n } from '@/locales/localizationInitializer'
import './styles/index.scss'

const app = createApp(App)
//app.config.performance = true;
const pinia=createPinia();
app.use(pinia);
initializeAppContext();
app.use(router);
createDefaultI18n().then(async (i18n) => {
  await router.isReady();
  app.use(i18n!);
  app.use(ElementPlus);
  app.use(components as any);
  app.mount('#app');
});


